import APIClient from '@/shared/http/clients/api'

const resourceName = 'funcionarios'
const APICore = process.env.APIBaseURLCore
/*
const Get = (countryId, config = {}) => APIClient.get(`${APIAccess}/${resourceName}`, config)
const GetLogged = (config = {}) => APIClient.get(`${APIAccess}/${resourceName}/logged`, config)
*/

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=name,asc&size=500`, data, config)
const GetAllNotInPa = (id = {}, data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/notinpa/${id}`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)
const UpdatePassword = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/password`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)
const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?${document}&page=${index}&size=${limit}`, config)

const EmployeeRepository = {
  GetAll,
  GetAllPaging,
  GetById,
  Create,
  Update,
  UpdatePassword,
  Delete,
  Search,
  GetAllNotInPa
}

export default EmployeeRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/employee.js